import { Dispatch } from 'redux';
import requests from '../requests';

export enum TopStocksConstants {
  TOP_STOCKS_REQUEST = 'TOP_STOCKS_REQUEST',
  TOP_STOCKS_SUCCESS = 'TOP_STOCKS_SUCCESS',
  TOP_STOCKS_FAILURE = 'TOP_STOCKS_FAILURE'
}

const topStocksService = {
  async getTopStocks (): Promise<TopStocks> {
    const resp = await requests.get('/api/top-stocks')
    return resp.data
  }
};

export function getTopStocks () {
  return async (dispatch: Dispatch<TopStocksAction>): Promise<void> => {
    const request = (): TopStocksDispatchType => ({ type: TopStocksConstants.TOP_STOCKS_REQUEST });
    const success = (payload: TopStocks): TopStocksDispatch => ({
      type: TopStocksConstants.TOP_STOCKS_SUCCESS, payload
    });
    const failure = (error: string): TopStocksErrorDispatchType => ({
      type: TopStocksConstants.TOP_STOCKS_FAILURE, error
    });

    dispatch(request());
    try {
      const content = await topStocksService.getTopStocks();
      dispatch(success(content));
    } catch (error: unknown) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dispatch(failure((error as any).response?.data?.error || 'Unknown error'));
    }
  };
}
